import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AIConsulting from "./pages/AIConsulting";
import AICreation from "./pages/AICreation";
import MediaBrand from "./pages/MediaBrand";
import SectorsPage from "./pages/SectorsPage";
import WorkPage from "./pages/WorkPage";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ai-consulting" element={<AIConsulting />} />
          <Route path="/ai-creation" element={<AICreation />} />
          <Route path="/media-brand" element={<MediaBrand />} />
          <Route path="/sectors" element={<SectorsPage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/about" element={<TeamPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
